module.exports = "<span *ngIf=\"!isEditing\">{{field.value}}</span>\r\n<input *ngIf=\"isEditing\" type=\"number\" [(ngModel)]=\"field.value\" class=\"form-control\" (change)=\"fieldUpdated.emit(field)\" placeholder=\"Enter a number\">"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/field/number/number.component.html
// module id = ../../../../../src/app/thought-module/field/number/number.component.html
// module chunks = main